import type { PublicBidRejectionGroundDto } from "../../../../autogen/bff-api";
import { getMarkdownFromTiptapContent } from "../../../../common/input/TipTap/markdownUtils";

export const REJECTION_COMPLAINT_INFO =
  "Eventuell klage på avvisningen kan rettes til oppdragsgiver eller til Klagenemnda for offentlige anskaffelser (KOFA), Postboks 511 Sentrum, 5805 Bergen, eller per e-post post@kofa.no.";

export const buildSupplierRejectionMessageMarkdown = (
  supplierName: string,
  grounds: PublicBidRejectionGroundDto[],
  messageByGroundKey: Record<string, string>,
) => {
  const supplier = supplierName.trim() || "leverandøren";
  const sections = grounds
    .map((ground) => {
      const message = getGroundMessageMarkdown(
        messageByGroundKey[ground.key] ?? "",
      );

      return [`**${ground.foaReference}**`, ground.label, message]
        .filter(Boolean)
        .join("\n\n");
    })
    .join("\n\n");

  return [
    `Leverandøren ${supplier} avvises fra konkurransen med hjemmel i følgende bestemmelser:`,
    sections,
    `**Klageadgang**\n\n${REJECTION_COMPLAINT_INFO}`,
  ]
    .filter(Boolean)
    .join("\n\n");
};

export const getGroundMessageMarkdown = (content: string) =>
  getMarkdownFromTiptapContent(content).trim();
